import React from "react";
import _ from "lodash";
import { connect } from "formik";
import { DecimalInput } from "components/Global/FormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const SideLabelDecimalInput = ({ label, fieldName, placeholder, formik, isDisabled, ...otherProps }) => {
  const val = _.get(formik.values, fieldName);

  return (
    <LateralField label={label}>
      {isDisabled && <ViewOnlyDiv>{val}</ViewOnlyDiv>}
      {!isDisabled && <DecimalInput
        fullWidth
        fieldName={fieldName}
        placeholder={placeholder}
        {...otherProps}
      />}
    </LateralField>
  );
};
export default connect(SideLabelDecimalInput);
